import React, { useEffect, useState, useRef, useContext } from "react";
import { Container, Col, Row } from "react-bootstrap";
import { useLocation, useParams } from "react-router-dom";
import "./CompanyAbout.css";
import URLstateContext from "../../../provider/CommonContext";
import { Modal } from "react-bootstrap";

function CompanyAbout(props) {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [modalIsOpen, setIsOpen] = React.useState(false);

  const location = useLocation();
  //const valCoCode = location.state.coCode;
  //const { exchg, cocode } = useParams();
  //console.log("here i am", valCoCode);
  // const [data, setData] = useState([]);
  const [companyInfo, setCompanyInfo] = useState([]);
  const [marketCapital, setMarketCapital] = useState([]);
  let actualData;
  let companyInformation;
  let marketCapiValue;
  let exchg = props.exchange;
  let cocode = props.coCode;
  const { BaseURL } = useContext(URLstateContext);

  function openModal() {
    setIsOpen(true);
  }

  useEffect(() => {
     
      const infoUrl = BaseURL + "AboutCompany";
      if (cocode != "") {
          fetch(`${infoUrl}/${props.coCode}`)
              .then((response) => response.json())
              .then((data) => {
                  companyInformation = data.data;
                  //console.log(data.data)
                  setCompanyInfo(companyInformation);
               //  console.log(companyInformation);
              });
      }
   

 
  }, [props.coCode]);
 
    
 
  const [isActive, setActive] = useState("false");
  const [text, setText] = useState("More");
  const knowMoreBtn = () => {
    //  setActive(!isActive);
    // setText("Less");
    handleShow();
  };
  const handleClosePopup = () => {
    setShow(false);
  }

  return (
    <>
      <section className="about-company-section">
        <Container className="table-boxabout colorabout">
          <Row>
            <div className="aboutComp">
            {(companyInfo === null) ? <div className="errorDiv"><h4 className="errormsgComNew">No Data Available !!!</h4></div> : ''}
              {companyInfo &&
                companyInfo.map(({ lname, bsemcap, ind_l_name, memo, Co_Code, }) => (
                  <>
                    <h3 key={Co_Code}>About {lname}</h3>
                    <ul>
                      <li>
                        <span>Sector : {ind_l_name}</span>
                      </li>
                      {/* <li>
                        <span>Market Capital : {bsemcap} Crore</span>
                      </li> */}
                    </ul>
                    <ul>
                      <li>
                        <span>MCAP : {bsemcap} Crore</span>
                      </li>
                    </ul>
                    <p className={isActive ? "heightNormal" : "heightMain"}>
                      {memo}
                    </p>
                  </>
                ))}
              {/* <ul>
                {marketCapital.map(({ MarketCap }) => (
                  <li>
                    <span>Market Capital : {MarketCap} Crore</span>
                  </li>
                ))}
              </ul> */}
              {/* <h3>About Reliance Industries Ltd</h3> */}
              {/* <ul>
                <li>
                  <span>Sector : Refineries</span>
                </li>
                <li>
                  <span>Market Capital : 1726990 Crore</span>
                </li>
              </ul> 
              {companyInfo.map(({ memo }) => (
                <p className={isActive ? "heightNormal" : "heightMain"}>
                  {memo}
                </p>
              ))}
              {/* <h6 >know more</h6> */}

              <h6 onClick={knowMoreBtn}>
                <span>Read {text}</span>
              </h6>

              {/* <button onClick={knowMoreBtn}>Open Modal</button> */}
              {companyInfo &&
                companyInfo.map(({ lname, bsemcap, ind_l_name, memo, Co_Code, }) => (
                  <Modal show={show} className="modal company-snap-modal">
                     
                      <Modal.Body id="modal_info">
                        <div className="titleCompany">{lname}</div>
                        <div className="btnDiv">
                          <div className="btncl" onClick={handleClosePopup} > X </div>
                          </div> 
                        <div className="infoCompany">{memo}</div>
                      </Modal.Body>
                     
                  </Modal>
                ))}
            </div>
          </Row>
        </Container>
      </section>
    </>
  );
}
export default CompanyAbout;
